const KILOBYTE = 1024;
const MEGABYTE = KILOBYTE * 1024;

export const formatFileSize = (bytes: number): string => {
  if (bytes < KILOBYTE) {
    return `${bytes}B`;
  }

  if (bytes < MEGABYTE) {
    return `${Math.round(bytes / KILOBYTE)}KB`;
  }

  return `${Math.round(bytes / MEGABYTE)}MB`;
};
